import { useMemo, useCallback } from 'react';
import useSWRInfinite from 'swr/infinite';
import { fetchWithTokenAndRegion } from '@adsk/acs-sc-web-platform-api';
/**
 * @param {UseSearchParams} search - search props
 * @returns {Object} - object with properties
 * @property {boolean} loading - is request loading
 * @property {Object} error - error object
 * @property {Object} data - data object
 * @property {number} pageSize - current page size
 * @property {function} setSize - function to change size
 * @property {function} nextPage - function to load next page
 * @property {boolean} hasNextPage - has next page
 * @property {function} retry - function to retry request
 */
const useSearch = _ref => {
  let {
    search,
    enabled,
    getKey
  } = _ref;
  const {
    data,
    error,
    mutate,
    setSize,
    size,
    isValidating
  } = useSWRInfinite(function () {
    for (var _len = arguments.length, swrAttrs = new Array(_len), _key = 0; _key < _len; _key++) {
      swrAttrs[_key] = arguments[_key];
    }
    return enabled && getKey(...swrAttrs, search);
  }, fetchWithTokenAndRegion, {
    revalidateIfStale: false,
    revalidateOnFocus: false,
    revalidateOnReconnect: false
  });
  const dataMemo = useMemo(() => {
    var _data$flatMap;
    return data === null || data === void 0 ? void 0 : (_data$flatMap = data.flatMap) === null || _data$flatMap === void 0 ? void 0 : _data$flatMap.call(data, page => page.results);
  }, [data]);
  const hasNextPage = useMemo(() => {
    var _data, _data$pagination;
    return !!(data !== null && data !== void 0 && (_data = data[size - 1]) !== null && _data !== void 0 && (_data$pagination = _data.pagination) !== null && _data$pagination !== void 0 && _data$pagination.nextUrl);
  }, [data, size]);
  const totalResults = useMemo(() => {
    var _data$, _data$$pagination;
    return data === null || data === void 0 ? void 0 : (_data$ = data[0]) === null || _data$ === void 0 ? void 0 : (_data$$pagination = _data$.pagination) === null || _data$$pagination === void 0 ? void 0 : _data$$pagination.totalResults;
  }, [data]);
  const nextPage = useCallback(() => setSize(size + 1), [setSize, size]);
  return {
    loading: isValidating,
    error,
    data: dataMemo,
    totalResults,
    pageSize: size,
    setPageSize: setSize,
    nextPage,
    hasNextPage,
    retry: mutate
  };
};
export default useSearch;
//# sourceMappingURL=useSearch.js.map